import { FC, memo } from 'react'
import styled from 'styled-components'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { List, ListItem } from '@ucheba/ui/components/List/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { IAboutCasesProps } from '../types'

const Block = styled.div``

/** Интересные кейсы */
const AboutCases: FC<IAboutCasesProps> = (props) => {
  const { items } = props

  return (
    <Block>
      <Heading h2='Интересные кейсы' spacing='large' />

      <List spacing='xlarge'>
        {items.map((item) => {
          return (
            <ListItem key={item.title}>
              <Heading h3={item.title} spacing='small' />

              <Text>{item.description}</Text>
            </ListItem>
          )
        })}
      </List>
    </Block>
  )
}

export default memo(AboutCases)
